module.exports = __webpack_public_path__ + "static/media/historyLogs.dba194f6.svg";